<template>
  <div style="height: calc(100vh - 70px)">
    <el-row>
      <el-col :span="24">
        <div class="grid-content" style="padding-top: 20px">
          <img class="common-img-icon" :src="apfConfig[group].schoolIcon" style="width: 30%; display: block; margin: 0 auto" />
          <img src="../../../assets/tick.png" style="width: 100px" />
          <h3 class="success-text">
            {{ appCustomTextConst['Thank you for your submission.'] }}
          </h3>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import appCustomTextConst from '@/pages/application/const/applicationCustomTextConst'
import apfConfig from '@/pages/application/config/apfConfig'

export default {
  props: ['group'],
  data() {
    return {
      apfConfig,
      appCustomTextConst: appCustomTextConst,
    }
  },
}
</script>
